import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { TitleProps } from './types';
import { HeadingStyleType } from '@constants/common';

const Title = (props: TitleProps) => {
  const {
    heading1,
    heading2,
    heading3,
    heading4,
    heading1Style,
    heading2Style,
    heading3Style,
    heading4Style,
  } = props.heading;
  return (
    <h2
      className={ivclass(
        'iv-text-center md:iv-text-left lg:iv-text-left xl:iv-text-left',
        'iv-m-heading-s md:iv-m-heading-2xl lg:iv-m-heading-4xl xl:iv-m-heading-5xl',
        'iv-text-heading-s md:iv-text-heading-2xl lg:iv-text-heading-4xl xl:iv-text-heading-5xl',
        'iv-font-extrabold',
      )}
    >
      <span
        className={ivclass(
          heading1Style === HeadingStyleType.Highlighted && 'iv-title-gradient',
          'iv-decoration-clone',
        )}
      >
        {heading1}
      </span>
      <span className={ivclass('iv-block sm:iv-inline')}>
        <span
          className={ivclass(
            heading2Style === HeadingStyleType.Highlighted &&
              'iv-title-gradient',
            'iv-decoration-clone',
          )}
        >
          {heading2}
        </span>
        <span
          className={ivclass(
            heading3Style === HeadingStyleType.Highlighted &&
              'iv-title-gradient',
            'iv-decoration-clone',
          )}
        >
          {heading3}
        </span>
      </span>
    </h2>
  );
};

export default Title;
